var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-wrapper"},[_c('intro-header'),_c('div',{staticClass:"intromain"},[_c(_vm.currentComponent,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }